import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from "../../../app.component";

@Component({
  selector: 'app-guideline-body',
  templateUrl: './guideline-body.component.html',
  styleUrls: ['./guideline-body.component.scss']
})
export class GuidelineBodyComponent implements OnInit {

  public baseUrl = myGlobals.baseFileUrl;

  startTime: any;
  currentVideoTime: any;

  playerVars: {
    autoplay: 0,
    modestbranding: 0,
    controls: 0,
    disablekb: 0,
    rel: 0,
    showinfo: 0,
    fs: 0,
    playsinline: 0,
  }

  constructor(private landingService: LandingServiceService) { }

  generalGuideline: any = [];
  expertGuideline:any=[];
  aicteGuideline:any=[];
  facultyGuideline: any = [];
  instituteGuideline: any = [];
  studentGuideline: any = [];
  allGuideline: any = [];
  tempGuideline: any = [];
  
  ngOnInit(): void {
    this.baseUrl = this.baseUrl + "/homepage/guidelines";
    this.landingService.getAllGuidelinesHome().subscribe((response) => {
      this.allGuideline = response['guidelines'];
      this.allGuideline.forEach((element) => {
        switch (element['role_id']) {
          // case 1:
          //   this.aicteGuideline.push(element);
          //   break;
          // case 3:
          //   this.expertGuideline.push(element);
          //   break;
          case 5:
            this.instituteGuideline.push(element);
            break;
          case 6:
            this.studentGuideline.push(element);
            break;
          case 8:
            this.facultyGuideline.push(element);
            break;
          default:
            this.generalGuideline.push(element);
            break;
        }
      });
      this.onClick(2);
    });
  }

  onClick(data) {
    switch(data) {
      case 1:
      this.tempGuideline = this.aicteGuideline;
      break;
    case 3:
      this.tempGuideline = this.expertGuideline;
      break;
    case 5:
      this.tempGuideline = this.instituteGuideline;
      break;
    case 6:
      this.tempGuideline = this.studentGuideline;
      break;
    case 8:
      this.tempGuideline = this.facultyGuideline;
      break;
    case 2:
      this.tempGuideline = this.generalGuideline;
      break;
    }
  }

}
